import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Home } from '../../interfaces/page';
declare var window;
import * as $ from 'jquery';

@Component({
  selector: 'app-home-section-crew',
  templateUrl: './home-section-crew.component.html',
  styleUrls: ['./home-section-crew.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush // Important to prevent shuffle from continuously run
})
export class HomeSectionCrewComponent implements OnInit {
  @Input() content: Home;
  @Input() homeTransition: boolean;

  constructor() { }

  calcHeightImage(): number {
    // Image has different aspect ratios for desktop vs tablet down sizes
    if ($(window).width() > 768) {
      return 55;
    } else {
      return 78;
    }
  }

  shuffle(array): any {
    let currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;

  }

  ngOnInit() {
  }

}
